// extracted by css-extract-rspack-plugin
export default {"iconButton":"ToolbarButton-module__iconButton__WwwAY"};